import type { NoteName } from '@tunasong/schemas'
import type { Chord, ChordType } from './chord-types.js'
import { ALL_CHORDS } from './all-chords.js'

/**
 * Create a regexp for the chords
 *
 * We reverse the Ids to match the special chords (e.g., Csus2) before the plain chord (C)
 */
const chordIds = Object.keys(ALL_CHORDS).reverse()
const chordRegexpStr = `(${chordIds.join('|')})([\n\r\t ]+|$)`
export const chordsRegexp = new RegExp(chordRegexpStr)

export const parseChordString = (text: string) => {
  // Pattern: root note, variant (maj7, add9, etc.), optional slash/bass note
  const pattern =
    /^([A-G][#b]*)(maj[0-9]*|min[0-9]*|m|dim|aug|sus[4|2]*|add[0-9]*|[b]?[0-9]*)?(sus2|sus4)?(?:\s*\/\s*([A-G][#b]?))?$/
  const match = text.match(pattern)

  return match
    ? ({
        root: match[1] as NoteName, // e.g., "C" from "C/E"
        variant: ((match[2]?.trim() ?? '') + (match[3]?.trim() ?? '')) as ChordType, // e.g., "maj7" from "Cmaj7/E"
        bassNote: match[4] as NoteName, // e.g., "E" from "C/E"
      } satisfies Chord)
    : undefined
}
